module.exports = __webpack_public_path__ + "img/slider_7.d6a1d5e8.jpg";